import { render, staticRenderFns } from "./SemenQuarantinetwo.vue?vue&type=template&id=3339bbf8&scoped=true&"
import script from "./SemenQuarantinetwo.vue?vue&type=script&lang=js&"
export * from "./SemenQuarantinetwo.vue?vue&type=script&lang=js&"
import style0 from "./SemenQuarantinetwo.vue?vue&type=style&index=0&id=3339bbf8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3339bbf8",
  null
  
)

export default component.exports